var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/~/lodash/_metaMap.js
// module id = 280
// module chunks = 0